import { render, staticRenderFns } from "./MedicationDefaultList.vue?vue&type=template&id=e0d19dda&lang=pug"
import script from "./MedicationDefaultList.vue?vue&type=script&lang=js"
export * from "./MedicationDefaultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports